import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import ColAtm from "../../../../atomic/Col/Col";
import ButtonAtm from "../../../../atomic/Button/Button";
import Dialog from "@material-ui/core/Dialog";
import {Grid, withStyles, MenuItem, CircularProgress} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogContent from "@material-ui/core/DialogContent/DialogContent";
import {GET_CONTENT_PDF} from "../../../../../constants/api.constants";
import axios from "axios";
import {ValidatorForm, TextValidator, SelectValidator} from 'react-material-ui-form-validator';
import {useForm} from "react-hook-form";
import {getAppLang, getProperty} from "../../../../../utils";
import {Alert} from "@material-ui/lab";
import {useSelector, useDispatch} from "react-redux";
import { getLanguages } from '../../../../../redux/actions/languageActions';

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)(props => {
    const {children, classes, onClose, ...other} = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon className="close-button"/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

export default function ContentCatalogMail(props) {
    const {handleSubmit} = useForm();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const languageList = useSelector(props => props.languagesReducer?.languages);

    const [openModal, setOpenModal] = useState(false);
    const [catalogEmail, setCatalogEmail] = useState("");
    const [message, setMessage] = useState("");
    const [language, setLanguage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setMessage("");
    }, []);

    useEffect(() => {
        if (!languageList || languageList.length === 0) {
            dispatch(getLanguages());
        }
    }, [dispatch]);

    const handleChange = ({target}) => {
        setCatalogEmail(target.value);
    };

    const onSubmit = (data, e) => {
        e.preventDefault();
        setIsLoading(true)

        const params = {
            params: {
                property_id: getProperty(),
                dataExport: "catalog",
                language: language || "",
                email: catalogEmail || ""
            }
        }

        axios.post(GET_CONTENT_PDF, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        })
            .then((result) => {
                setMessage("success");
                setIsLoading(false)
                setTimeout(() => {
                    setOpenModal(false);
                    setMessage("");
                }, 1000);
            })
            .catch(function (error) {
                setMessage("error")
                setIsLoading(false)
            })
    };

    const modalOpen = () => {
        setMessage("");
        setOpenModal(true)
        setCatalogEmail("")
        setLanguage("")
        setIsLoading(false)
    }

    const changeLanguage = ({target}) => {
        setLanguage(target.value)
    };

    return (
        <div>
            <button className="download-content-photo-btn" onClick={modalOpen}>
                <i className="fas fa-file-alt" style={{marginRight: "4px"}}/> {t('enw-catalog-title')}
            </button>
            <Dialog onClose={() => setOpenModal(false)} aria-labelledby="status" open={openModal}
                    className="web-preview-dialog catalog-mail-dialog">
                <DialogTitle className="red-bottom-border" id="status" onClose={() => setOpenModal(false)}>
                    {t('enw-catalog-title')}
                </DialogTitle>
                <DialogContent>
                    <Grid container className="p-24">
                        {message === "success" &&
                        <Alert className="w-100" severity="success">{t('enw-success-message')}</Alert>}
                        {message === "error" &&
                        <Alert className="w-100" severity="error">{t('enw-error-message')}</Alert>}
                        <ValidatorForm onSubmit={handleSubmit(onSubmit)} onError={errors => console.log(errors)} className="w-100">
                            <SelectValidator
                                name="catalogLanguage"
                                onChange={changeLanguage}
                                value={language}
                                className="form-control"
                                variant="outlined"
                                fullWidth
                                label={ t('enw-input-language') }
                                validators={['required']}
                                errorMessages={[ t("enw-notification_this_is_required") ]}
                            >
                            {
                                languageList?.map((lang) => (
                                    <MenuItem key={lang.code} value={lang.code}>
                                        <img src={`/assets/img/language/${lang.code}.svg`} alt="en"
                                                style={{width: 20, marginRight: 8}}/> {t(lang.language_key)}
                                    </MenuItem>
                                ))
                            }
                            </SelectValidator>
                            <TextValidator
                                name="catalogEmail"
                                type="text"
                                fullWidth
                                value={catalogEmail}
                                variant="outlined"
                                label={t('myweb-contact-mail_title')}
                                placeholder={t('myweb-input-placeholder-enter_email')}
                                autoComplete="off"
                                onChange={handleChange}
                                validators={['required', 'isEmail']}
                                errorMessages={[t("enw-notification_this_is_required"), t('enw-notification_invalid_email') ]}
                            />
                            <ColAtm className="mt-20" md={12}>
                                <p style={{fontWeight: "500", fontSize: "15px"}}>{t('enw-catalog-desc')}</p>
                            </ColAtm>
                            <ColAtm className="mt-20" md={12}>
                                <ButtonAtm
                                    className="m-auto room-rate-modal-save bg-red"
                                    buttontext={ 
                                        isLoading ?
                                        <CircularProgress className='catalog-circular' style={{color:"#fff", zIndex: "99"}} /> 
                                        : 
                                        t('btn-send')
                                    }
                                    color="primary"
                                    type="submit"
                                    disabled={isLoading ? true : false}
                                />
                            </ColAtm>
                        </ValidatorForm>
                    </Grid>
                </DialogContent>
            </Dialog>
            <style>{`
                @media screen and (min-width: 768px) {
                    .catalog-mail-dialog .MuiDialog-paperWidthSm {
                        max-width:600px !important;
                        width:600px !important
                    }
                }
                .catalog-circular {
                    top: 12% !important;
                    left: 45% !important;
                    width: 30px !important;
                    height:30px !important;
                }
            `}</style>
        </div>
    );
}